import React from 'react';
import { SearchDialogAnchor, SearchAnchorWrapper, AbsoluteContainer } from './search-anchor.styled';
export var SearchAnchor = function SearchAnchor(_ref) {
  var children = _ref.children,
    onBlur = _ref.onBlur,
    onFocus = _ref.onFocus,
    onKeyDown = _ref.onKeyDown,
    isExpanded = _ref.isExpanded,
    shouldFillContainer = _ref.shouldFillContainer;
  return /*#__PURE__*/React.createElement(SearchAnchorWrapper, {
    shouldFillContainer: shouldFillContainer
  }, /*#__PURE__*/React.createElement(AbsoluteContainer, {
    shouldFillContainer: shouldFillContainer,
    isExpanded: isExpanded
  }, /*#__PURE__*/React.createElement(SearchDialogAnchor, {
    onBlur: onBlur,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    isExpanded: isExpanded,
    shouldFillContainer: shouldFillContainer
  }, children)));
};